import {useEffect, useState, useContext, useRef} from "react";
import theme from "theme";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Item from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Info from "@mui/icons-material/Info";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import CircularProgress from "@mui/material/CircularProgress";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { DataContext } from "contexts/DataContext";
import 'i18n/config';
import { useTranslation } from "react-i18next";
import { setApplicable } from "./api";
import { getAISuggestions } from "./api";
import { Check } from "@mui/icons-material";

interface AssessmentControlProps {
    control: any;
    controls: any;
    selectControl: (control: string) => void;
    formRef: React.RefObject<HTMLFormElement>;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
    setReloadNavigator?: (reload: boolean) => void;
}
const AssessmentControl = (props: AssessmentControlProps) => {
    const { t } = useTranslation();
    const dataContext = useContext(DataContext);
    const [maturities, setMaturities] = useState([] as any);
    const [coverages, setCoverages] = useState([] as any);
    const [id_maturity, setIdMaturity] = useState('');
    const [id_coverage, setIdCoverage] = useState('');
    const [controls, setControls] = useState([] as any);

    const [active, setActive] = useState(false);
    const notApplicableRef = useRef({} as any);
    const notApplicableTextRef = useRef({} as any);

    const [keyDown, setKeyDown] = useState(false as any);


    const [AILoading, setAILoading] = useState(false);
    const [AIResponse, setAIResponse] = useState(false as any);
    const [AISource, setAISource] = useState([] as any);

    const handleAIClick = () => {
        dataContext.changeShowLoader(true);
        setAILoading(true);
        getAISuggestions(props.control?.control_description).then(response => {
            let json = '';
            try {
                json = JSON.parse(response.result);
            } catch (error) {
                json = response.result;
            }
            //let source_documents = JSON.parse(response.source_documents);
            console.log(json);
            console.log(response.source_documents);
            setAIResponse(json);
            setAISource(response.source_documents);
            dataContext.changeShowLoader(false);
            setAILoading(false);
        }) 
    }

    const setCoverage = () => {
    
    }
  useEffect(() => {

    // handle what happens on key press
    const handleKeyUp = () => {
        setKeyDown(false);
    }

    const handleKeyDown = (event:any) => {
        //console.log(keyDown);
        if(keyDown==='Control' && event.key==='Enter') {
            props.formRef.current?.setAttribute('gotoNext', '1');
            props.formRef.current?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
        setKeyDown(event.key);
    }

    // attach the event listener
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    // remove the event listener
    return () => {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('keyup', handleKeyUp);
    };
  });

    useEffect(() => {
        if(dataContext.loading) return;
        setControls(props.controls);
        setActive(props.control?.active ? true : false);
        setCoverages(dataContext.coverages);
        setMaturities(dataContext.maturities);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dataContext.loading]);

    var changeTimeout = null as any;
    const handleChange = () => {
        var check = notApplicableRef?.current as HTMLInputElement;
        var text = notApplicableTextRef?.current as HTMLInputElement;
        setActive(check.checked);
        if(check.checked || text.value) {
            if(changeTimeout) clearTimeout(changeTimeout);
            changeTimeout = setTimeout(() => {
                //Salvo se applicabile o non applicabile ma cè un testo
                    setApplicable(props.control?.id, check.checked, text?.value);
                    if(props.controls) {      
                        props.controls.find((control: any) => control.id === props.control?.id).active = check.checked;
                        setControls([...props.controls]);
                        props.setReloadNavigator && props.setReloadNavigator(true);
                    }    
            }, 500);
        }
    };

    return (
        <>
        {props.control?.id_control && 
        <Box                     
        sx={{visibility: !dataContext.showLoader ? 'visible': 'visible'}}
        display={'flex'} flexDirection={'column'} justifyContent={'space-around'} height={'100%'}>
            <Box sx={{margin:1}}>
            <Typography variant="controlTitle">
                {props.control?.subcategory_fncs}
            </Typography>
            <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                
            <Typography sx={{fontSize:12}}>
                <strong>OWNER:</strong> {props.control?.owner_name} ({props.control?.owner_email ?? t('No owner set')})
            </Typography>
            <Typography sx={{fontSize:12}}>
                <span><strong>{t('Priority')}</strong>: {props.control?.subcategory_priority} </span>
                <span><strong>{t('Class')}</strong>: {props.control?.subcategory_class} </span>
                <span><strong>{t('Relevant')}</strong>: {props.control?.subcategory_relevant} </span>
            </Typography>
            </Box>

            </Box>
            <Divider />
            <Box sx={{margin:1, marginBottom:0}}>
            <Typography variant="controlTitle">
                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                    <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>{props.control?.id_control} 
                        {!AILoading && <AutoAwesome onClick={handleAIClick} sx={{marginLeft:1, fontSize:18}} />}
                        {AILoading && <Box sx={{display:'flex', flexDirection:'row', alignItems:'center', fontWeight:'normal'}}><CircularProgress sx={{marginLeft:1, marginRight:1}} size={18} /> Loading AI suggestions...</Box>}
                    </Box>
                    <FormControlLabel 
                    sx={{background: active ? '' : 'rgba(255, 255, 255, 0.09)', margin:0, marginRight: -1, boxShadow: 'none', borderRadius: '5px 5px 0 0' , padding:0}}
                    control={
                        <Checkbox 
                            defaultChecked={props.control?.active ? true : false} 
                            size={'small'} 
                            inputRef={notApplicableRef}
                            onChange={handleChange} />
                    } 
                    label={
                        <Typography sx={{fontSize:14, marginRight:1}}>{active ? t("Applicable") : t("Not applicable")}</Typography>
                    } />
                </Box>
            </Typography>
            </Box>

            <Box ref={props.formRef} component="form" onSubmit={props.handleSubmit} noValidate>
            <Box sx={{marginBottom:2}}>
                    <TextField
                        inputRef={notApplicableTextRef}
                        name={'notes'}
                        multiline
                        maxRows={4}
                        sx={{ minHeight: '100%', display: !active ? 'block' : 'none'}}
                        InputProps={{ sx: { borderRadius: 0 } }}
                        variant="filled"
                        fullWidth
                        hiddenLabel
                        onChange={handleChange}
                        defaultValue={props.control.notes ?? ''}
                    />
            </Box>
            </Box>

            {AIResponse &&
            <Box sx={{margin:1, backgroundColor:'#DF8F39', borderRadius:5, padding:2}}>
                <Box>
                    <Typography variant="controlText" sx={{fontSize:18}}>
                    <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}><AutoAwesome sx={{marginRight:1, fontSize:22}} /> {t('AI suggestions')}</Box>
                </Typography>
                </Box>
                <Box sx={{marginTop:2}}>
                <Typography variant="controlText" sx={{fontSize:14, fontWeight:600}}>
                    <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>{t('Coverage')}: {AIResponse.coverage} </Box>
                </Typography>
                </Box>
                <Box>
                <Typography variant="controlText" sx={{fontSize:14}}>
                    {AIResponse.coverage_explanation}
                </Typography>
                </Box>

                <Box sx={{marginTop:2}}>
                <Typography variant="controlText" sx={{fontSize:14, fontWeight:600}}>
                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>{t('Maturity')}: {AIResponse.maturity} </Box>
                </Typography>
                </Box>
                <Box>
                <Typography variant="controlText" sx={{fontSize:14}}>
                    {AIResponse.maturity_explanation}
                </Typography>
                </Box>

                <Box sx={{marginTop:2}}>
                <Typography variant="controlText" sx={{fontSize:14, fontWeight:600}}>
                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>{t('This AI Suggestions are based on the following sources:')}</Box>
                </Typography>
                </Box>
                {AISource.map((source:any) => (
                    <Box>
                    <Typography variant="controlText" sx={{fontSize:14}}>
                        {source.metadata.source.replace('./docs/','')} <u>pagina {source.metadata.page}</u> score {Math.round(source.metadata.score)}%
                    </Typography>
                    </Box>
                ))}

            </Box>}

            <Box sx={{margin:1}}>
            <Typography variant="controlText" sx={{fontSize:14}}>
                {props.control?.control_description}
            </Typography>
            </Box>

            {active && 
            <Box ref={props.formRef} component="form" onSubmit={props.handleSubmit} noValidate sx={{ mt: 2 }}>
                <Box sx={{marginBottom:2}}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Item>
                        <FormControl sx={{minWidth:100, marginRight:2}} fullWidth>
                            <InputLabel id="coverage-select-label">{t("Coverage")}</InputLabel>
                            {coverages.length>0 &&
                            <Select
                                key={id_coverage}
                                //startAdornment={
                                //(id_coverage ? id_coverage : props.control?.id_coverage) ?
                                //<InputAdornment position="start">
                                //    <Tooltip title= {
                                //        (coverages.find((coverageRow: any) => coverageRow.id === (id_coverage ? id_coverage : props.control?.id_coverage)))?.description ?? 'Choose a coverage value'
                                //        }>
                                //        <Info />
                                //    </Tooltip>
                                //</InputAdornment>
                                //: null}
                            labelId="coverage-select-label"
                            label={t("Coverage")}
                            value={id_coverage ? id_coverage : props.control.id_coverage ?? ''}
                            onChange={(e) => setIdCoverage(e.target.value)}
                            name="coverage"
                            >
                            {coverages.map((coverage: any, index: number) => {
                                return (
                                    <MenuItem key={index} value={coverage.id}>{coverage.name}</MenuItem>
                                )
                            })}
                            </Select>}
                        </FormControl>
                        </Item>
                    </Grid>
                    <Grid item xs={8}>
                        <Item>
                        <TextField
                                name={'coverage_notes'}
                                multiline
                                maxRows={4}
                                sx={{ minHeight: '100%' }}
                                variant="filled"
                                fullWidth
                                hiddenLabel
                                defaultValue={props.control.coverage_notes ?? ''}
                            />

                        </Item>
                    </Grid>
                    <Grid item xs={12}>
                        <Item>
                            <Box sx={{fontSize:12}}>
                                {(coverages.find((coverageRow: any) => coverageRow.id === (id_coverage ? id_coverage : props.control?.id_coverage)))?.description ?? ''}
                            </Box>
                        </Item>
                    </Grid>
                </Grid>
                </Box>

                <Box>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Item>
                        <FormControl sx={{minWidth:100, marginRight:2}} fullWidth>
                            <InputLabel id="maturity-select-label">{t("Maturity")}</InputLabel>
                            {maturities.length>0 && 
                            <Select
                                key={id_maturity}
                                //startAdornment={
                                //(id_maturity ? id_maturity : props.control?.id_maturity) ?
                                //<InputAdornment position="start">
                                //    <Tooltip title= {
                                //        (maturities.find((maturityRow: any) => maturityRow.id === (id_maturity ? id_maturity : props.control?.id_maturity)))?.description ?? ''
                                //        }>
                                //        <Info />
                                //    </Tooltip>
                                //</InputAdornment>
                                //: null}
                            labelId="maturity-select-label"
                            label={t("Maturity")}
                            value={id_maturity ? id_maturity : props.control.id_maturity ?? ''}
                            onChange={(e) => setIdMaturity(e.target.value)}
                            name="maturity"
                            >
                            {maturities.map((maturity: any, index: number) => {
                                return (
                                    <MenuItem key={index} value={maturity.id}>{maturity.name}</MenuItem>
                                )
                            })}
                            </Select>}
                        </FormControl>
                        </Item>
                    </Grid>
                    <Grid item xs={8}>
                        <Item>
                            <TextField
                                name={'maturity_notes'}
                                multiline
                                maxRows={4}
                                sx={{ minHeight: '100%' }}
                                variant="filled"
                                fullWidth
                                hiddenLabel
                                defaultValue={props.control.maturity_notes ?? ''}
                            />
                        </Item>
                    </Grid>
                    <Grid item xs={12}>
                        <Item>
                            <Box sx={{fontSize:12}}>
                                {(maturities.find((maturityRow: any) => maturityRow.id === (id_maturity ? id_maturity : props.control?.id_maturity)))?.description ?? ''}
                            </Box>
                        </Item>
                    </Grid>
                </Grid>
                </Box>
            </Box>}

            <Divider sx={{marginTop:4}}/>
            <Box justifySelf={'flex-end'} sx={{display:"flex", flexWrap:"wrap", flexDirection:"row", justifyContent: "center", marginTop:4}}>
                {controls?.map((control: any, index: number) => {
                    return (
                        <Box 
                        key={index}
                        onClick={() => props.selectControl(control)}
                        sx={{
                            background: (
                                !control.active && props.control?.id_control===control.id_control ? theme.palette.error.main :
                                control.id_coverage && control.id_maturity 
                                    ? props.control?.id_control===control.id_control ? theme.palette.success.main : 'white'
                                    : props.control?.id_control===control.id_control ? theme.palette.primary.main : 'white'
                            ),
                            color: (
                                !control.active && props.control?.id_control===control.id_control ? 'white' :
                                !control.active && props.control?.id_control!==control.id_control ? theme.palette.error.main :
                                control.id_coverage && control.id_maturity // controllo completo
                                ? props.control?.id_control===control.id_control ? 'white' : theme.palette.success.main
                                : props.control?.id_control===control.id_control ? 'white' : theme.palette.primary.main
                            ),
                            borderColor: (
                                !control.active ? theme.palette.error.main :
                                control.id_coverage && control.id_maturity // controllo completo
                                    ? theme.palette.success.main 
                                    : theme.palette.primary.main
                            ),
                            borderWidth: 3,
                            borderStyle: "solid",
                            borderRadius: 20,
                            padding:1,
                            minWidth: 50,
                            minHeight: 50,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            margin: "5px",
                            cursor: "pointer"
                        }}>
                            <span>{index+1}</span>
                        </Box>
                    )
                })}
            </Box>

        </Box>}
        </>
    );
    };

export default AssessmentControl;